import * as types from './types';
import { fetchGeneric } from 'State/generic/actions';

export const getCalendars = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.MBEREPORT_GETCALENDARS,
        types.MBEREPORT_FETCHING,
        types.MBEREPORT_FETCHERROR,
        `SchoolCalendar`
      )
    );
  };
};

export const getReport = postData => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.MBEREPORT_GETREPORT,
        types.MBEREPORT_FETCHING,
        types.MBEREPORT_FETCHERROR,
        `Reports/GetMBEReport`,
        postData
      )
    );
  };
};

export const getControlInfo = () => {
  return dispatch => {
    dispatch(
      fetchGeneric(
        types.MBEREPORT_GETCONTROLINFO,
        types.MBEREPORT_FETCHING,
        types.MBEREPORT_FETCHERROR,
        `ControlInfo/1`
      )
    );
  };
};

export const clearReport = () => {
  return dispatch => {
    dispatch({ type: types.MBEREPORT_CLEARREPORT });
  };
};



// WEBPACK FOOTER //
// ./src/pages/mbereport/state/actions.js